export const GLEAN_APP_URL = '//atlassian.glean.com/embedded-search-latest.min.js';
